import React, { lazy, Suspense } from 'react';
import { Route, Switch, Redirect, useHistory } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import PermissionGuard2 from '../../../../Layout/PermissionGuard2';

const WastageList = lazy(() => import('../Pages/Wastage/WastageList'));
const AddWastage = lazy(() => import('../Pages/Wastage/AddWastage'));
const EditWastage = lazy(() => import('../Pages/Wastage/EditWastage'));
const WastageView = lazy(() => import('../Pages/Wastage/WastageView'));
const TransferDiscrepancyList = lazy(() => import('../Pages/TransferDiscrepancy/TransferDiscrepancyList'));
const ActualVsTheoreticalReport = lazy(() => import('../Pages/Reports/ActualVsTheoreticalReport'));
const ExpiryRiskMonitor = lazy(() => import('../Pages/Reports/ExpiryRiskMonitor'));
const StockCountList = lazy(() => import('../Pages/StockCount/StockCountList'));
const AddStockCount = lazy(() => import('../Pages/StockCount/AddStockCount'));
const StockCountView = lazy(() => import('../Pages/StockCount/StockCountView'));

const Loading = () => (
  <div className="d-flex justify-content-center align-items-center p-5">
    <Spinner animation="border" variant="primary" />
  </div>
);

function InventoryControlRoutes() {
  const history = useHistory();

  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route
          exact
          path="/:lng/stock/inventory-control/wastage"
          render={() => (
            <React.Fragment>
              <WastageList />
            </React.Fragment>
          )}
        />
        <Route
          exact
          path="/:lng/stock/inventory-control/wastage/add"
          render={() => (
            <React.Fragment>
              <AddWastage />
            </React.Fragment>
          )}
        />
        <Route
          exact
          path="/:lng/stock/inventory-control/wastage/edit/:slack"
          render={() => (
            <React.Fragment>
              <EditWastage />
            </React.Fragment>
          )}
        />
        <Route
          exact
          path="/:lng/stock/inventory-control/wastage/view/:slack"
          render={() => (
            <React.Fragment>
              <WastageView />
            </React.Fragment>
          )}
        />
        <Route
          exact
          path="/:lng/stock/inventory-control/discrepancies"
          render={() => (
            <React.Fragment>
              <TransferDiscrepancyList />
            </React.Fragment>
          )}
        />
        <Route
          exact
          path="/:lng/stock/inventory-control/reports/actual-vs-theoretical"
          render={() => (
            <React.Fragment>
              <ActualVsTheoreticalReport />
            </React.Fragment>
          )}
        />
        <Route
          exact
          path="/:lng/stock/inventory-control/reports/expiry-risk"
          render={() => (
            <React.Fragment>
              <ExpiryRiskMonitor />
            </React.Fragment>
          )}
        />
        <Route
          exact
          path="/:lng/stock/inventory-control/stock-count"
          render={() => (
            <PermissionGuard2 history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
              <Suspense fallback={<Loading />}>
                <StockCountList />
              </Suspense>
            </PermissionGuard2>
          )}
        />
        <Route
          exact
          path="/:lng/stock/inventory-control/stock-count/add"
          render={() => (
            <PermissionGuard2 history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
              <Suspense fallback={<Loading />}>
                <AddStockCount />
              </Suspense>
            </PermissionGuard2>
          )}
        />
        <Route
          exact
          path="/:lng/stock/inventory-control/stock-count/view/:slack"
          render={() => (
            <PermissionGuard2 history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
              <Suspense fallback={<Loading />}>
                <StockCountView />
              </Suspense>
            </PermissionGuard2>
          )}
        />
        <Redirect to="/:lng/stock/inventory-control/wastage" />
      </Switch>
    </Suspense>
  );
}

export default InventoryControlRoutes;

